import React from 'react';
import { InfoIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-ink-900 px-5 pb-32 pt-12 sm:px-8 sm:pb-36" data-id="element-150" data-mp="207kogf5rsc9b">
      <div className="mx-auto max-w-3xl" data-id="element-151" data-mp="2f4tjpjy7206b">
        <h2 className="flex items-center justify-center gap-2 text-center font-display text-sm font-bold uppercase tracking-[0.18em] text-white/60" data-id="element-152" data-mp="2f3iinrw4v6iw">
          <InfoIcon className="h-4 w-4" aria-hidden="true" data-id="element-153" data-mp="1mg5uxee8kso0" />
          Important Educational Disclaimer
        </h2>

        <p className="mt-4 text-center text-[13px] leading-relaxed text-white/50 sm:text-sm" data-id="element-154" data-mp="1hhbbca8g302u">
          The Master System of TRT™ is an educational resource intended for qualified healthcare
          professionals. It does not replace professional clinical judgment, current clinical
          practice guidelines, official prescribing information, or appropriate specialist
          consultation.
        </p>
        <p className="mt-3 text-center text-[13px] leading-relaxed text-white/50 sm:text-sm" data-id="element-155" data-mp="yrd8q9nf1z6l">
          Clinical decisions should always be individualized according to the patient’s history,
          examination, laboratory findings, risk factors, applicable regulations, and the most
          current evidence available.
        </p>

        <p className="mt-8 text-center text-[11px] font-semibold uppercase tracking-[0.14em] text-white/35" data-id="element-156" data-mp="1nb5w87pulgn1">
          © 2026 Master System of TRT™. All rights reserved.
        </p>
      </div>
    </footer>;
}